import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { v4 as uuidv4 } from "uuid";

dayjs.extend(duration);

export const SESSION_ID_KEY = "sessionId";
export const TIME_TO_LIVE = dayjs.duration({ minutes: 15 });
export const REFRESH_RATE = TIME_TO_LIVE.subtract(1, "minute");
export const COOKIE_PATH = "/";

export const newFeatureFlagsSessionId = () => {
  return `${uuidv4()}/${dayjs().valueOf()}`;
};
